import VideoCard from "../../components/common/VideoCard";
import useSelectVideo from "../../hooks/useSelectVideo";
import { useLocation, useNavigate } from "react-router-dom";

export default function GlobalSearch(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const selectVideo = useSelectVideo();
    const { posts = [], loading, usersData, groupSearchData, SearchItems, handleJoinGroup, handleNavigate } = props;
    const filterData = Array.isArray(posts.results) ? posts.results.filter((item) => item.video_url !== null) : [];

    // Functions
    const handleSelectVideo = async (id) => {
        selectVideo(id, filterData, location.pathname, "Posts");
    };

    return (
        <>
            {Array.isArray(usersData) && usersData?.length > 0 &&
                <div className="flex items-center justify-between px-2">
                    <p className="text-[14px] font-bold text-blue-600">Users</p>
                </div>
            }

            <div className="px-2">
                {Array.isArray(usersData) && usersData?.map((data) => (
                    <div
                        key={data?.id}
                        className="flex flex-row items-center py-2 text-black cursor-pointer border-b border-gray-200 dark:border-gray-800 dark:text-white"
                    >
                        <img
                            alt={data?.full_name}
                            src={data?.avatar_url}
                            onClick={() => handleNavigate(data?.id)}
                            className="h-10 w-10 rounded-full border border-gray-400 dark:border-gray-800 object-cover"
                        />
                        <div className="ml-2">
                            <p
                                onClick={() => handleNavigate(data.id)}
                                className="text-[14px] md:text-[12px] dark:text-[white] font-bold first-letter:uppercase line-clamp-2"
                            >
                                {data?.full_name}
                            </p>
                            <p className="text-[10px] line-clamp-1 dark:text-[white]">
                                {data?.username}
                            </p>
                            <p className="text-[10px] text-gray-600 dark:text-gray-400">
                                {data?.mutual_friends?.length > 0 ?
                                    `.Followed ${data.mutual_friends[0]?.username} 
                                                ${data?.mutual_friends?.length > 1 ? `+${data?.mutual_friends?.length - 1} others` : ""}`
                                    : ""
                                }
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {SearchItems?.SearchResult?.trending_hashtags?.results?.length > 0 &&
                <div className="flex items-center justify-between px-2 pt-4 pb-2">
                    <p className="text-[14px] font-bold text-blue-600">HashTags</p>
                </div>
            }

            {SearchItems?.SearchResult?.trending_hashtags?.results?.length > 0 &&
                SearchItems?.SearchResult?.trending_hashtags?.results?.map((data) => (
                    <div
                        key={data.post_count}
                        className="flex flex-col mb-2 px-2 cursor-pointer"
                        onClick={() => navigate(`/hashtag/${data?.hashtag}`)}
                    >
                        <p className="text-[14px] text-black dark:text-white font-bold">{data?.hashtag}</p>
                        <p className="text-[10px] text-gray-500">{data?.post_count} posts</p>
                    </div>
                ))
            }

            {/* {groupSearchData?.length > 0 &&
                <div className="flex items-center justify-between px-2 pt-4">
                    <p className="text-[14px] font-bold text-blue-600">Groups</p>
                </div>
            }

            <div className="px-2">
                {groupSearchData?.length > 0 && (
                    groupSearchData.map((data, index) => (
                        <div key={data.id} className="border-b border-gray-200 dark:border-gray-800 py-2">
                            <div className="grid grid-cols-12 items-start">
                                <div className="col-span-2">
                                    <img
                                        alt={data.group_name}
                                        src={data.group_profile_picture}
                                        onClick={() => navigate(`/group/${data.id}`)}
                                        className="w-10 h-10 rounded-full object-cover border border-gray-300 dark:border-gray-800 cursor-pointer"
                                    />
                                </div>
                                <div className="col-span-7 flex flex-col">
                                    <p
                                        onClick={() => navigate(`/group/${data.id}`)}
                                        className="font-semibold text-[12px] text-black dark:text-white cursor-pointer"
                                    >
                                        {data.group_name}
                                    </p>
                                    <p
                                        onClick={() => navigate(`/group/${data.id}`)}
                                        className="text-[12px] text-gray-800 dark:text-gray-300 line-clamp-1 leading-[14px] mt-[6px] cursor-pointer"
                                    >
                                        {data.description}
                                    </p>
                                </div>
                                <div className="col-span-3 flex flex-col justify-between items-end">
                                    {data.join_request_status !== "pending" ? (
                                        data?.user_joined ? (
                                            <button
                                                onClick={() => navigate(`/group/${data.id}`)}
                                                className="bg-gray-500 text-white dark:bg-white dark:text-black rounded-md text-[11px] p-1 w-full font-semibold"
                                            >
                                                Joined
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => handleJoinGroup(data.id)}
                                                className="bg-black text-white dark:bg-white dark:text-black rounded-md text-[11px] p-1 w-full font-semibold"
                                            >
                                                Join
                                            </button>
                                        )
                                    ) : (
                                        <button
                                            onClick={() => navigate(`/group/${data.id}`)}
                                            className="bg-light-blue-500 text-white rounded-md text-[11px] p-1 w-full font-semibold"
                                        >
                                            Requested
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div> */}

            {filterData?.length > 0 &&
                <div className="flex items-center justify-between px-2 pt-2">
                    <p className="text-[14px] font-bold text-blue-600">Posts</p>
                </div>
            }

            <div className="grid grid-cols-3 gap-1 overflow-scroll no-scrollbar p-2">
                {filterData?.map((data) => (
                    <VideoCard
                        id={data.id}
                        body={data.body}
                        belowDecs={true}
                        threeDots={false}
                        video={data.video_url}
                        view_count={data.view_count}
                        likes_count={data.likes_count}
                        authorId={data.created_by?.id}
                        selectVideo={handleSelectVideo}
                        avatar_url={data.created_by.avatar_url}
                    />
                ))}
            </div>

            {filterData?.length === 0 && groupSearchData?.length === 0 && usersData?.users?.length === 0 && !loading && (
                <div className="text-gray-600 dark:text-white text-[12px] text-center mt-5 px-2">
                    No Data Found
                </div>
            )}
        </>
    );
}
